import { defineStore } from 'pinia'

// initial state
const state = () => ({
  startPageDrag: false,
  currentPageIndex: null,
  pageDragPaddingBottom: 0,
  pageDragPaddingTop: 0,
  clbs: new Set(),
})

// functionName: (state, getters, rootState) => {}
const getters = {}

// functionName ({ commit, state, dispatch }, param, ...) {}
const actions = {
  dragEnd() {
    this.startPageDrag = false
    this.pageDragPaddingTop = 0
    this.pageDragPaddingBottom = 0
    this.currentPageIndex = null
  },
  dragWillStart(index) {
    this.currentPageIndex = index
    this.clbs.forEach(clb => {
      clb()
    })
  },
  dragStart(index) {
    this.currentPageIndex = index
    this.startPageDrag = true
  },
}

export default defineStore({
  id: 'dnd',
  state,
  getters,
  actions
})
